<template>
    <div>

        <main role="main">

            <div class="container-fluid">


                <div class="row mt-2 mb-2">
                    <div class="col-md-12">

                        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

                        <div class="row">
                            <div class="col-md-12 mb-5">
                                <b-nav tabs>
                                    <b-nav-item @click="routerGoTo('transactions')" >{{$t('text.apmPages.transactionsLabel')}}</b-nav-item>
                                    <b-nav-item @click="routerGoTo('errors')">{{$t('text.apmPages.errors')}}</b-nav-item>
                                    <b-nav-item @click="routerGoTo('metrics')" active>{{$t('text.apmPages.metrics')}}</b-nav-item>
                                </b-nav>
                            </div>
                        </div>

                        <h3 class="mb-5">
                            {{this.$route.params.serviceName}}
                        </h3>

                        <div class="row mt-3 mb-3">

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="startTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="dddd, MMMM Do YYYY, HH:mm"
                                                      v-model="startTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="endTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="dddd, MMMM Do YYYY, HH:mm" v-model="endTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>
                        </div>


                        <div class="row mt-3" id="wrapper">
                            <div class="col-md-6">
                                <div id="chart-line" class="mt-3">
                                    <label for="transaction-duration">{{$t('text.apmPages.transactionDuration')}}</label>
                                    <apexchart id="transaction-duration" type=line height="300"
                                               :options="transactionDurationChartOptions"
                                               :series="transactionDurationSeries"
                                               :key="transactionDurationDataLoaded"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="chart-line2" class="mt-3">
                                    <label for="requests-per-minute">{{$t('text.apmPages.requestsPerMinute')}}</label>
                                    <apexchart id="requests-per-minute" type=line height="300"
                                               :options="requestsPerMinuteChartOptions"
                                               :series="requestsPerMinuteSeries"
                                               :key="requestsPerMinuteDataLoaded"/>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3" id="wrapper2">

                            <div class="col-md-12">
                                <div id="chart-bar" class="mt-3">
                                    <label for="error-occurrences">{{$t('text.apmPages.errorOccurrences')}}</label>
                                    <apexchart id="error-occurrences" type="bar" height="300"
                                               :options="errorOccurrencesChartOptions"
                                               :series="errorOccurrencesChartSeries"
                                               :key="errorOccurrencesChartDataLoaded"/>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3" id="wrapper3">
                            <div class="col-md-6">
                                <div id="chart-line3" class="mt-3">
                                    <label for="transaction-duration">{{$t('text.apmPages.apmMetrics.cpuUsage')}}</label>
                                    <apexchart id="cpu-usage" type=line height="300"
                                               :options="cpuUsageChartOptions"
                                               :series="cpuUsageSeries"
                                               :key="cpuUsageDataLoaded"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="chart-line4" class="mt-3">
                                    <label for="requests-per-minute">{{$t('text.apmPages.apmMetrics.memoryUsage')}}</label>
                                    <apexchart id="memory-usage" type=line height="300"
                                               :options="memoryUsageChartOptions"
                                               :series="memoryUsageSeries"
                                               :key="memoryUsageDataLoaded"/>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>


            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import {VueGoodTable} from 'vue-good-table';
    import axios from 'axios/index';

    library.add(faHome);


    export default {
        name: 'Transactions',
        components: {
            SidebarNavigation
        },
        data() {
            return {
                startTimestamp: null,
                endTimestamp: null,
                startTimeDate: null,
                endTimeDate: null,
                transactionDurationDataLoaded: false,
                requestsPerMinuteDataLoaded: false,
                errorOccurrencesChartDataLoaded: false,
                cpuUsageDataLoaded: false,
                memoryUsageDataLoaded: false,
                transactionDurationSeries: [],
                requestsPerMinuteSeries: [],
                errorOccurrencesChartSeries: [{
                    name: '',
                    data: []
                }],
                cpuUsageSeries: [],
                memoryUsageSeries: [],
                transactionDurationChartOptions: {
                    colors: ['#3185fc', '#e6c220', '#f98510'],

                    chart: {
                        group: 'transactionData',
                        id: 'transactionDuration'
                    },
                    xaxis: {
                        type: "datetime"
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return Math.round(value / 1000) + " ms";
                            },
                            minWidth: 0
                        },

                    },
                    stroke: {
                        width: 3
                    },
                    legend: {
                        position: 'bottom',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                    },
                },
                requestsPerMinuteChartOptions: {
                    colors: ['#00b3a4', '#f98510', '#db1374'],

                    chart: {
                        group: 'transactionData',
                        id: 'requestsPerMinute'
                    },
                    xaxis: {
                        type: "datetime"
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return Math.round(value) + " rpm";
                            },
                            minWidth: 0
                        },

                    },
                    stroke: {
                        width: 3
                    },
                    legend: {
                        position: 'bottom',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                    },
                },
                errorOccurrencesChartOptions: {
                    colors: ['#80bcd2'],
                    plotOptions: {
                        bar: {
                            vertical: true,
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        id: 'errorOccurrences'
                    },
                    xaxis: {
                        type: "datetime",
                        categories: []
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return value + " occ.";
                            }
                        }
                    },
                    stroke: {
                        width: 1
                    }
                },
                cpuUsageChartOptions: {
                    colors: ['#3185fc', '#00b3a4', '#e6c220', '#f98510'],

                    chart: {
                        group: 'usageData',
                        id: 'cpu-usage'
                    },
                    xaxis: {
                        type: "datetime"
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return parseInt(value * 100) + "%"
                            },
                            minWidth: 0
                        },
                        tickAmount: 2,
                        max: 1,
                        min: 0

                    },
                    stroke: {
                        width: 3
                    },
                    legend: {
                        position: 'bottom',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                    },
                },
                memoryUsageChartOptions: {
                    colors: ['#00b3a4', '#f98510', '#db1374'],

                    chart: {
                        group: 'usageData',
                        id: 'memory-usage'
                    },
                    xaxis: {
                        type: "datetime"
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return parseInt(value * 100) + "%"
                            },
                            minWidth: 0
                        },
                        tickAmount: 2,
                        max: 1,
                        min: 0

                    },
                    stroke: {
                        width: 3
                    },
                    legend: {
                        position: 'bottom',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                    },
                },
                breadcrumbItems: [
                    {
                        text:  this.$t('text.apmPages.apmLabel'),
                        href: '#/apm'
                    },
                    {
                        text: this.$route.params.serviceName,
                        href: '#/transactions/' + encodeURIComponent(this.$route.params.serviceName)
                    },
                    {
                        text:  this.$t('text.apmPages.metrics'),
                        active: true
                    }
                ]
            }
        },
        mounted() {
            this.initDate();
        },

        watch: {
            '$route'(to, from) {
                // react to route changes...


                this.initDate();


            }

        },

        methods: {




            updateTimes(){

                this.$router.push({
                    path: "",
                    query:{
                        start: encodeURIComponent(this.startTimestamp),
                        end: encodeURIComponent(this.endTimestamp)
                    }
                });


            },

            routerGoTo(where){

                this.$router.push("/" + where + "/"+ this.$route.params.serviceName + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp));

            },

            getData() {
                const _this = this;

                this.transactionDurationDataLoaded = false;
                this.requestsPerMinuteDataLoaded = false;


                console.log("cas zacetka: ", this.startTimestamp);
                console.log("cas konca: ", this.endTimestamp);

                axios.get(config.kibana + this.$route.params.serviceName + "/transaction_groups/charts?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&uiFilters=%7B%7D", {headers: {}})
                    .then((res) => {

                        // transaction duration graf
                        console.log("response za transaction duration graf:", res.data);
                        this.transactionDurationSeries[0] = {data: [], name: this.$t('text.apmPages.average')};
                        this.transactionDurationSeries[1] = {data: [], name: this.$t('text.apmPages.ninetyFifthPercentile')};
                        this.transactionDurationSeries[2] = {data: [], name: this.$t('text.apmPages.ninetyNinthPercentile')};
                        this.transactionDurationSeries[0].data = res.data.apmTimeseries.responseTimes.avg;
                        this.transactionDurationSeries[1].data = res.data.apmTimeseries.responseTimes.p95;
                        this.transactionDurationSeries[2].data = res.data.apmTimeseries.responseTimes.p99;
                        this.transactionDurationDataLoaded = true;
                        console.log("transactionDurationSeries", this.transactionDurationSeries);

                        // requests per minute graf

                        for (var i = 0; i < res.data.apmTimeseries.tpmBuckets.length; i++) {
                            this.requestsPerMinuteSeries[i] = {
                                name: res.data.apmTimeseries.tpmBuckets[i].key,
                                data: res.data.apmTimeseries.tpmBuckets[i].dataPoints,
                            }
                        }
                        this.requestsPerMinuteDataLoaded = true;
                        console.log("requestsPerMinuteSeries", this.requestsPerMinuteSeries);


                    })
                    .catch((error) => {
                        console.log(error);
                    });


                axios.get(config.kibana + this.$route.params.serviceName + "/errors/distribution?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&uiFilters=%7B%7D", {headers: {}})
                    .then((res) => {

                        // errors graf
                        console.log("response za transaction duration graf:", _.map(res.data.buckets, 'count'));

                        _this.errorOccurrencesChartSeries[0] = {
                            name: "test",
                            data: _.map(res.data.buckets, 'count')
                        };

                        for (let i = 0; i < res.data.buckets.length; i++) {
                            _this.errorOccurrencesChartOptions.xaxis.categories[i] = res.data.buckets[i].key;
                        }

                        _this.errorOccurrencesChartDataLoaded = true;
                        console.log("errorOccurrencesChartDataLoaded", _this.errorOccurrencesChartDataLoaded);
                        console.log("_this.errorOccurrencesChartOptions", _this.errorOccurrencesChartOptions);

                    })
                    .catch((error) => {
                        console.log(error);
                    });


                axios.get(config.kibana + this.$route.params.serviceName + "/metrics/charts?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&agentName=java" + "&uiFilters=%7B%7D", {headers: {}})
                    .then((res) => {

                        // CPU usage graf
                        console.log("response za CPU usage graf:", res.data.charts[0]);
                        this.cpuUsageSeries[0] = {data: [], name: this.$t('text.apmPages.systemMax') + ": " + parseFloat(res.data.charts[0].series[0].overallValue * 100).toFixed(1) + "%"};
                        this.cpuUsageSeries[1] = {data: [], name: this.$t('text.apmPages.systemAverage') + ": " + parseFloat(res.data.charts[0].series[1].overallValue * 100).toFixed(1) + "%"};
                        this.cpuUsageSeries[2] = {data: [], name: this.$t('text.apmPages.processMax') + ": " + parseFloat(res.data.charts[0].series[2].overallValue * 100).toFixed(1) + "%"};
                        this.cpuUsageSeries[3] = {data: [], name: this.$t('text.apmPages.processAverage') + ": " + parseFloat(res.data.charts[0].series[3].overallValue * 100).toFixed(1) + "%"};
                        this.cpuUsageSeries[0].data = res.data.charts[0].series[0].data;
                        this.cpuUsageSeries[1].data = res.data.charts[0].series[1].data;
                        this.cpuUsageSeries[2].data = res.data.charts[0].series[2].data;
                        this.cpuUsageSeries[3].data = res.data.charts[0].series[3].data;
                        this.cpuUsageDataLoaded = true;
                        console.log("cpuUsageSeries", this.cpuUsageSeries);

                        // Memory usage graf
                        console.log("response za Memory usage graf:", res.data.memory);
                        this.memoryUsageSeries[0] = {data: [], name: this.$t('text.apmPages.systemMax') + " " + parseFloat(res.data.charts[1].series[0].overallValue * 100).toFixed(1) + "%"};
                        this.memoryUsageSeries[1] = {data: [], name: this.$t('text.apmPages.systemAverage') + " " + parseFloat(res.data.charts[1].series[1].overallValue * 100).toFixed(1) + "%"};
                        this.memoryUsageSeries[0].data = res.data.charts[1].series[0].data;
                        this.memoryUsageSeries[1].data = res.data.charts[1].series[1].data;
                        this.memoryUsageDataLoaded = true;
                        console.log("memoryUsageSeries", this.memoryUsageSeries);
                    })
                    .catch((error) => {
                        console.log(error);
                    });

            },

            initDate() {

                if (this.$route.query.start == null && this.$route.query.end == null) {
                    this.endTimeDate = new Date();
                    this.startTimeDate = new Date();
                    this.startTimeDate.setDate(this.endTimeDate.getDate() - 1);
                    this.startTimestamp = this.startTimeDate.toISOString();
                    this.endTimestamp = this.endTimeDate.toISOString();

                    this.$router.push({
                        path: "",
                        query:{
                            start: encodeURIComponent(this.startTimestamp),
                            end: encodeURIComponent(this.endTimestamp)
                        }
                    });

                } else {

                    this.startTimestamp = decodeURIComponent(this.$route.query.start);
                    this.endTimestamp = decodeURIComponent(this.$route.query.end);


                }

                this.breadcrumbItems[0].href = "#/apm/" + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.breadcrumbItems[1].href = "#/transactions/" + encodeURIComponent(this.$route.params.serviceName) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.getData();
            },


            formatMiliseconds(value) {
                return Math.round(value / 1000) + " " + this.$t('text.apmPages.ms');
            },

            formatTransactionsPerMinute(value) {
                return +parseFloat(value).toFixed(1) + " " + this.$t('text.apmPages.tpm');
            },

            onCellClick(params) {
                console.log(params);
                let transactionGroup = params.formattedRow.name;

                this.$router.push('/transactions/' + this.$route.params.serviceName + '/' + encodeURIComponent(transactionGroup));
            }

        },
        beforeCreate: function () {
            document.body.className = 'transactions';
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/ApmMetrics.vue